import { takeLatest, call, put, all, select } from 'redux-saga/effects';
import { project, loading, toast, modal } from '../types';
import { generateCreateProjectform } from '../utils/form';
import { teamWork, projects as projectPath } from '../router/roleWisePageRoute';
import scogo_apis from '../scogo_apis';

export function* createProject(action) {
    const { formName, projectForm, navigate, orgId, name, type } = action.payload;
    const { preCreatedProjectId } = yield select((state) => state.project);
    const requestBody = { ...projectForm };
    if (preCreatedProjectId) {
        requestBody.id = preCreatedProjectId;
    }

    try {
        if (requestBody.create_end_user) {
            const endUserResponse = yield call(scogo_apis.org.postEntities, {}, { orgId }, {}, { name: requestBody.create_end_user, type: 'END_USER' });
            delete requestBody.create_end_user;
            if (endUserResponse.status === 201) {
                requestBody.end_user_id = endUserResponse.data.data.id
            }
        }

        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
        let response = yield call(scogo_apis.projects.createProject, {}, {}, {}, requestBody);
        if (response.status === 201) {
            yield put({ type: project.PRE_CREATED_PROJECT_ID, payload: { projectId: null } });
            yield put({ type: modal.CLOSE_MODAL });
            yield put({ type: toast.SEND_TOAST, payload: { status: 'success', message: 'Project Added Succesfully' } });
            yield put({ type: project.IS_SHOW_ADD_PROJECT, payload: { isOpen: false } });
            yield put({ type: project.REFRESH_PROJECT_LIST });
        } else {
            yield put({ type: project.CREATE_PROJECT_FAILURE, payload: { message: 'Oops Something went wrong' } });
            yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: 'Something went wrong' } });
        }
    } catch (error) {
        yield put({ type: project.CREATE_PROJECT_FAILURE, payload: error });
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: error.response.data.messages[0] || 'Something went wrong' } });
    }
    yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
}
export function* createProjectPost(action) {
    const { projectId, formName, payload } = action.payload;


    try {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
        let response = yield call(scogo_apis.projects.projectPost, {}, { projectId }, {}, payload);

        if (response.status === 201) {
            yield put({ type: modal.CLOSE_MODAL });
            yield put({ type: project.GET_PROJECT_POST_LIST_REQUEST, payload: { projectId } });
        }

    } catch (error) {
        console.error('Create Project Post Error:', error);
        yield put({ type: project.CREATE_PROJECT_FAILURE, payload: error });
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: 'Something went wrong' } });
    } finally {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
    }
};

export function* getProjectListData(action) {
    const { limit = 100, page = 1, query, dropdown, payload } = action.payload;
    try {
        if (dropdown) {
            yield put({ type: loading.SET_PROJECT_DROPDOWN_LIST_LOADING, payload: true });
        } else {
            yield put({ type: loading.SET_PROJECT_LIST_LOADING, payload: true });
        }
        yield put({ type: project.SET_FILTER_PAYLOAD, payload: action.payload });
        const queryParams = { limit, page, ...payload };
        if (query) {
            queryParams.q = query;

        }
        const response = yield call(scogo_apis.projects.getProjectListData, {}, {}, queryParams);
        if (response.status === 200) {
            if (dropdown) {
                const d_data = response.data.data.map(({ id, name, org_id, milestones, payments, end_user, organization, custom_ticket_fields, default_helpdesk_id, category }) => ({ value: id, label: name, key: id, org_id, milestones, payments, end_user, organization, custom_ticket_fields, default_helpdesk_id, category }));
                yield put({
                    type: project.GET_PROJECTS_DROPDOWN_LIST_DATA_SUCCESS,
                    payload: {
                        projectListData: d_data,
                        query
                    }
                });
            } else {
                yield put({
                    type: project.GET_PROJECTS_LIST_DATA_SUCCESS,
                    payload: {
                        projectListData: response.data.data,
                        page,
                        has_next_page: response.data.data.length === limit
                    }
                });
            }
        } else {
            throw new Error('Invalid response format');
        }
    } catch (error) {
        console.error('Saga error:', error);
        yield put({
            type: project.GET_PROJECTS_LIST_DATA_FAILURE,
            payload: error
        });
    } finally {
        if (dropdown) {
            yield put({ type: loading.SET_PROJECT_DROPDOWN_LIST_LOADING, payload: false });
        } else {
            yield put({ type: loading.SET_PROJECT_LIST_LOADING, payload: false });
        }
    }
};

export function* getAutoAcceptProjectList(action) {
    const { category, query, page = 1, append = false } = action.payload;
    const limit = 100;
    try {
        yield put({ type: loading.IS_AUTO_ACCEPT_PROJECT_LIST_LOADING, payload: true });
        const queryParams = { limit, page };
        if (category) queryParams.category = category;
        if (query) queryParams.q = query;
        const response = yield call(scogo_apis.projects.getProjectListData, {}, {}, queryParams);
        if (response.status === 200) {
            const projects = Array.isArray(response?.data?.data) ? response.data.data : [];
            // A full page implies there may be more (no total count is returned), matching
            // the has_next_page convention used by getProjectListData above.
            const hasMore = projects.length === limit;
            yield put({ type: project.GET_AUTO_ACCEPT_PROJECT_LIST_SUCCESS, payload: { projects, page, append, hasMore } });
        } else {
            yield put({ type: project.GET_AUTO_ACCEPT_PROJECT_LIST_FAILURE, payload: { append } });
        }
    } catch (error) {
        console.error('getAutoAcceptProjectList error:', error);
        yield put({ type: project.GET_AUTO_ACCEPT_PROJECT_LIST_FAILURE, payload: { append } });
    }
    yield put({ type: loading.IS_AUTO_ACCEPT_PROJECT_LIST_LOADING, payload: false });
}

export function* getContactPersonDetails(action) {
    const { orgId } = action.payload;
    let xOrgId = orgId
    try {
        yield put({ type: loading.SET_PROJECT_LIST_LOADING, payload: true });

        const response = yield call(scogo_apis.projects.getContact, {}, { xOrgId }, {}, {});
        if (response.status === 200) {
            yield put({ type: project.GET_CONTACT_PERSON_DETAILS_SUCCESS, payload: response });

        } else {
            throw new Error('Invalid response format');
        }
    } catch (error) {

    }
};

export function* getProjectDetail(action) {
    const { projectId } = action.payload;

    try {
        yield put({ type: loading.SET_PROJECT_DETAILS_LOADING, payload: true });

        const response = yield call(scogo_apis.projects.getProjectDetail, {}, { projectId }, {}, {});

        if (response.status === 200) {
            yield put({ type: project.GET_PROJECT_DETAIL_SUCCESS, payload: response.data.data });

        } else {
            throw new Error('Invalid response format');
        }
    } catch (error) {

    }
    yield put({ type: loading.SET_PROJECT_DETAILS_LOADING, payload: false });
};

export function* updateProjectDetail(action) {
    const { projectId, projectForm, formName, source } = action.payload;
    try {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
        const response = yield call(scogo_apis.projects.updateProject, {}, { projectId }, {}, projectForm);
        if (response.status === 200) {
            yield put({ type: project.UPDATE_PROJECT_SUCCESS, payload: { projectId, projectForm, source } });
            yield put({ type: modal.CLOSE_MODAL });
            yield put({ type: toast.SEND_TOAST, payload: { status: 'success', message: 'Project Updated Succesfully!!!' } })
        } else {
            yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: 'Something went wrong' } });
        }
    } catch (error) {
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: 'Something went wrong' } });
    }
    yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
};

export function* getProjectPmsList(action) {
    const { can_manage_projects, limit = 100, page = 1, query, org_id } = action.payload;
    const queryParams = { can_manage_projects, limit, page, org_id };
    if (query) queryParams.q = query;
    yield put({ type: loading.SET_PROJECT_PM_LIST_LOADING, payload: true });
    try {
        const response = yield call(scogo_apis.user.getUsersList, {}, {}, queryParams);
        if (response.status === 200) {
            const data = response.data.data.map((item) => ({
                name: item.full_name,
                email: item.email,
                mobile: item.mobile,
                id: item.id,
                key: item.id,
                value: item.id,
                label: item.full_name,
            }));
            yield put({ type: project.GET_PROJECT_ELIGIBLE_PMS_LIST_SUCCESS, payload: { query, data } });
        }
    }
    catch (error) { }
    yield put({ type: loading.SET_PROJECT_PM_LIST_LOADING, payload: false });
}

export function* getTeamListOFProject(action) {
    const { projectId } = action.payload;
    try {
        yield put({ type: loading.SET_PROJECT_TEAM_LIST_LOADING, payload: true });
        const response = yield call(scogo_apis.projects.getProjectTeams, {}, { projectId }, {}, {});
        if (response.status === 200) {
            yield put({ type: project.GET_TEAM_LIST_OF_PROJECT_SUCCESS, payload: { projectId, data: response.data.data } });
        } else {
            throw new Error('Invalid response format');
        }
    } catch (error) {

    }
    yield put({ type: loading.SET_PROJECT_TEAM_LIST_LOADING, payload: false });
}

export function* addTeamToProject(action) {
    const { projectId, team_ids, formName } = action.payload;
    try {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
        const response = yield call(scogo_apis.projects.addTeamToProject, {}, { projectId }, {}, { team_ids });
        if (response.status === 201) {
            yield put({ type: modal.CLOSE_MODAL })
            yield put({ type: toast.SEND_TOAST, payload: { status: 'success', message: response.data.message || 'Team added to project successfully' } });
            yield put({ type: project.GET_TEAM_LIST_OF_PROJECT_REQUEST, payload: { projectId } });
        }
    } catch (error) {
        console.log('error:', error);
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: error.response.data.messages[0] || 'Something went wrong' } });

    }
    yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
}

export function* removeTeamFromProject(action) {
    const { projectId, team_ids, formName } = action.payload;
    try {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
        const response = yield call(scogo_apis.projects.removeTeamFromProject, {}, { projectId }, {}, { team_ids });
        if (response.status === 201) {
            yield put({ type: modal.CLOSE_MODAL })
            yield put({ type: project.REMOVE_TEAM_FROM_PROJECT_SUCCESS, payload: { projectId, team_ids } });
            yield put({ type: toast.SEND_TOAST, payload: { status: 'success', message: response.data.message || 'Team removed from project successfully' } });
        } else {
            throw new Error('Invalid response format');
        }
    } catch (error) {
        console.log('error:', error)
    } finally {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
    }
}

export function* getProjectPostList(action) {
    const { projectId } = action.payload;

    try {
        yield put({ type: loading.PROJECT_POST_LOADING, payload: true });
        const response = yield call(scogo_apis.projects.getProjectPost, {}, { projectId }, {}, {});
        if (response.status === 200) {
            yield put({ type: project.GET_PROJECT_POST_LIST_SUCCESS, payload: { projectId, postList: response.data.data } });
        } else {
            yield put({ type: project.GET_PROJECT_POST_LIST_FAILURE, payload: 'Oops, something went wrong' });
        }
    } catch (error) {
        console.error('Get Project Post List Error:', error);
        yield put({ type: project.GET_PROJECT_POST_LIST_FAILURE, payload: error });
    } finally {
        yield put({ type: loading.PROJECT_POST_LOADING, payload: false });
    }
}

export function* updateProjectPost(action) {
    const { projectId, postId, status, formName } = action.payload;
    try {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
        const response = yield call(scogo_apis.projects.updateProjectPost, {}, { projectId, postId }, {}, { status });
        if (response.status === 200) {
            yield put({ type: project.UPDATE_PROJECT_POST_SUCCESS, payload: { projectId, postId, updatedPost: response.data.data } });
        } else {
            throw new Error('Invalid response format');
        }
    } catch (error) {
        console.log('error:', error)
    }
    yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
}
export function* getMilestoneList(action) {
    const { projectId } = action.payload;
    try {

        const response = yield call(scogo_apis.projects.getMilestoneList, {}, { projectId }, {}, {});
        if (response.status === 200) {
            yield put({ type: project.GET_MILESTONE_LIST_SUCCESS, payload: response.data.data });
        } else {
            throw new Error('Invalid response format');
        }
    } catch (error) {
        console.log('error:', error)
    }

}

export function* postMilestone(action) {
    const { projectId, milestone, formName } = action.payload;

    try {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
        const response = yield call(scogo_apis.projects.postMileStone, {}, { projectId }, {}, milestone);
        if (response.status === 201) {
            yield put({ type: project.POST_MILESTONE_SUCCESS, payload: response.data.data });
            yield put({ type: modal.CLOSE_MODAL })
            yield put({ type: project.REFRESH_PROJECT_LIST });
        } else {
            throw new Error('Invalid response format');
        }
    } catch (error) {
        console.log('error:', error)
    }
    finally {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
    }
}

export function* getProjectFilterList(action) {
    const { filter_labels } = action.payload;
    try {
        yield put({ type: loading.SET_PROJECT_FILTER_LIST_LOADING, payload: true });
        const response = yield call(scogo_apis.projects.getFilterList, {}, {}, { filter_labels });
        if (response.status === 200) {
            yield put({ type: project.GET_PROJECT_FILTER_LIST_SUCCESS, payload: response.data.data });
        } else {
            throw new Error('Invalid response format');
        }
    } catch (error) {
        console.log('error:', error)
    }
    yield put({ type: loading.SET_PROJECT_FILTER_LIST_LOADING, payload: false });
}


export function* postMilestoneById(action) {
    const { projectId, projectMilestoneId, milestone } = action.payload;
    try {
        yield put({ type: loading.SET_PROJECT_LIST_LOADING, payload: true });
        const response = yield call(scogo_apis.projects.postMilestoneById, {}, { projectId, projectMilestoneId }, {}, { milestone });
        if (response.status === 200) {
            yield put({ type: project.POST_MILESTONE_BY_ID_SUCCESS, payload: response.data.data });
        } else {
            throw new Error('Invalid response format');
        }
    } catch (error) {
        console.log('error:', error)
    }
}

export function* postProjectManager(action) {
    const { payload, projectId, formName } = action.payload;
    try {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
        const response = yield call(scogo_apis.projects.postProjectManager, {}, { id: projectId }, {}, payload);
        if (response.status === 201) {
            yield put({ type: project.POST_PROJECT_MANAGER_SUCCESS, payload: { managers: response.data.data, projectId } });
            yield put({ type: modal.CLOSE_MODAL });
            yield put({ type: toast.SEND_TOAST, payload: { status: 'success', message: response.data.message ? response.data.message : 'Project managers updated successfully' } });
        } else {
            yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: 'Failed to update project managers' } });
        }
    } catch (error) {
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: 'Failed to update project managers' } });
    } finally {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
    }
}
export function* getProjectManager(action) {
    const { projectId } = action.payload;
    try {
        yield put({ type: loading.SET_PROJECT_LIST_LOADING, payload: true });
        const response = yield call(scogo_apis.projects.getProjectManager, {}, { id: projectId }, {}, {});
        if (response.status === 200) {
            // Keep the original response structure
            yield put({ type: project.GET_PROJECT_MANAGER_SUCCESS, payload: response.data.data });
        } else {
            throw new Error('Invalid response format');
        }
    } catch (error) {
        console.log('error:', error)
    } finally {
        yield put({ type: loading.SET_PROJECT_LIST_LOADING, payload: false });
    }
}
export function* addTeamsToProject(action) {
    const { id, team_ids } = action.payload
    try {
        const res = yield call(scogo_apis.projects.postTeamProject, {}, { id: id }, {}, { team_ids })
        if (res.status === 201) {
            yield put({ type: project.ADD_TEAMS_TO_PROJECT_SUCCESS, payload: res.data.data });
            yield put({ type: toast.SEND_TOAST, payload: { status: 'success', message: 'Teams added to project successfully' } });
            yield put({ type: modal.CLOSE_MODAL })
        }
    } catch (err) {
        console.log('err:', err)
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: Array.isArray(err.response.data.messages) ? err.response.data.messages[0] : err.response.data.messages || 'Something Went Wrong!!' } });
    }
}

export function* getMilestones(action) {
    const { org_id, query, dropdown, limit, page } = action.payload;
    const queryParams = { org_id, dropdown, limit, page };
    if (query) queryParams.q = query;
    try {
        yield put({ type: loading.SET_MILESTONES_LOADING, payload: true });
        const response = yield call(scogo_apis.milestones.getMilestones, {}, {}, queryParams);
        if (response.status === 200) {
            if (dropdown) {
                const d_data = response.data.data.map((element) => ({ value: element.id, label: element.type, key: element.id, milestone: element }));
                yield put({ type: project.GET_MILESTONES_DROPDOWN_SUCCESS, payload: d_data });
            } else {
                yield put({ type: project.GET_MILESTONES_SUCCESS, payload: response.data.data });
            }
        }
    } catch (error) {
        console.log('error:', error)
    } finally {
        yield put({ type: loading.SET_MILESTONES_LOADING, payload: false });
    }
}


export function* blackListUserFromProject(action) {
    const { projectId, user_id, formName, team_id } = action.payload;
    try {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
        const response = yield call(scogo_apis.projects.blackListUser, {}, { projectId }, {}, { user_id });
        if (response.status === 201) {
            yield put({ type: project.BLACK_LIST_USER_FROM_PROJECT_SUCCESS, payload: { projectId, user_id, team_id } });
            yield put({ type: toast.SEND_TOAST, payload: { status: 'success', message: response.data.message || 'User added to blacklist successfully' } });
            yield put({ type: modal.CLOSE_MODAL })
        } else {
            throw new Error('Invalid response format');
        }
    } catch (error) {
        console.log('error:', error)
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: error.response.data.messages[0] || 'Something went wrong' } });
    } finally {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
    }
}

export function* whiteListUserFromProject(action) {
    const { projectId, user_id, formName, team_id } = action.payload;
    try {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
        const response = yield call(scogo_apis.projects.whiteListUser, {}, { projectId }, {}, { user_id });
        if (response.status === 201) {
            yield put({ type: project.WHITE_LIST_USER_FROM_PROJECT_SUCCESS, payload: { projectId, user_id, team_id } });
            yield put({ type: toast.SEND_TOAST, payload: { status: 'success', message: response.data.message || 'User added to whitelist successfully' } });
            yield put({ type: modal.CLOSE_MODAL })
        } else {
            throw new Error('Invalid response format');
        }
    } catch (error) {
        console.log('error:', error)
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: error.response.data.messages[0] || 'Something went wrong' } });
    } finally {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
    }
}


export function* refreshProjectList(action) {
    const filterPayload = yield select((state) => state.project.projectFilterPayload);
    yield put({ type: project.GET_PROJECTS_LIST_DATA_REQUEST, payload: filterPayload });
}


export function* addProjectPo(action) {
    const { projectId, payload, formName } = action.payload;
    try {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
        const response = yield call(scogo_apis.projects.addProjectPo, {}, { id: projectId }, {}, payload);
        if (response.status === 200) {
            yield put({ type: modal.CLOSE_MODAL })
            yield put({ type: toast.SEND_TOAST, payload: { status: 'success', message: response.data.message || 'PO added to project successfully' } });
            yield put({ type: project.REFRESH_PROJECT_LIST });
        } else {
            throw new Error('Invalid response format');
        }
    } catch (error) {
        console.log('error:', error)
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: error.response.data.messages[0] || 'Something went wrong' } });
    }
    finally {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
    }
}

export function* editProjectPo(action) {
    const { projectId, poId, amount, formName } = action.payload;

    try {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
        const response = yield call(scogo_apis.projects.editProjectPo, {}, { id: projectId, ponumber: poId }, {}, { amount });
        if (response.status === 200) {
            yield put({ type: modal.CLOSE_MODAL })
            yield put({ type: toast.SEND_TOAST, payload: { status: 'success', message: response.data.message || 'PO updated successfully' } });
            yield put({ type: project.REFRESH_PROJECT_LIST });
        } else {
            throw new Error('Invalid response format');
        }
    } catch (error) {
        console.log('error:', error)
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: error.response.data.messages[0] || 'Something went wrong' } });
    }
    finally {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
    }
}

export function* getProjectPo(action) {
    const { projectId } = action.payload;
    try {
        yield put({ type: loading.SET_PROJECT_DETAILS_LOADING, payload: true });
        const response = yield call(scogo_apis.projects.getProjectPo, {}, { id: projectId }, {}, {});
        if (response.status === 200) {
            yield put({ type: project.GET_PROJECT_PO_SUCCESS, payload: response.data });
        } else {
            throw new Error('Invalid response format');
        }
    } catch (error) {
        console.log('error:', error)
    } finally {
        yield put({ type: loading.SET_PROJECT_DETAILS_LOADING, payload: false });
    }
}

export function* getProjectChecklist(action) {
    const { projectId } = action.payload;
    try {
        const response = yield call(scogo_apis.projects.getProjectChecklist, {}, { projectId }, {}, {});
        if (response.status === 200) {
            yield put({ type: project.GET_PROJECT_CHECKLIST_SUCCESS, payload: response.data });
        } else {
            throw new Error('Invalid response format');
        }
    } catch (error) {
        console.log('error:', error)
    }
}

export function* editProjectChecklist(action) {
    const { projectId, checklistId, checklist, formName } = action.payload;
    try {
        if (formName) {
            yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
        }
        const requestBody = checklist?.tasks || checklist;
        const response = yield call(scogo_apis.projects.editProjectChecklist, {}, { projectId, checklistId }, {}, { tasks: requestBody });
        if (response.status === 201) {
            yield put({ type: project.EDIT_PROJECT_CHECKLIST_SUCCESS, payload: response.data });
            yield put({ type: toast.SEND_TOAST, payload: { status: 'success', message: response.data.message || 'Checklist updated successfully' } });
            yield put({ type: modal.CLOSE_MODAL });
        } else {
            throw new Error('Invalid response format');
        }
    } catch (error) {
        console.log('error:', error);
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: error.response?.data?.messages?.[0] || 'Something went wrong' } });
    } finally {
        if (formName) {
            yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
        }
    }
}


export function* activateProject(action) {
    const { id, payload, formName, source } = action.payload;
    try {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: true } });
        const response = yield call(scogo_apis.projects.activateProject, {}, { id }, {}, payload);
        if (response.status === 200) {
            yield put({ type: toast.SEND_TOAST, payload: { status: 'success', message: response.data.message || 'Project activated successfully' } });
            yield put({ type: modal.CLOSE_MODAL });
            if (source === 'details') {
                yield put({ type: project.UPDATE_PROJECT_DETAIL_SUCCESS, payload: { projectId: id, updatedProjectDetail: response.data.data } });
            } else {
                yield put({ type: project.REFRESH_PROJECT_LIST });
            }
        }
    } catch (error) {
        console.log('error:', error)
        yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: error.response?.data?.messages?.[0] || 'Something went wrong' } });
    } finally {
        yield put({ type: loading.FORM_BUTTON_LOADING, payload: { formName, isLoading: false } });
    }
}



export default function* projectSaga() {
    yield takeLatest(project.CREATE_PROJECT_REQUEST, createProject);
    yield takeLatest(project.CREATE_PROJECT_POST_REQUEST, createProjectPost);
    yield takeLatest(project.GET_PROJECT_POST_LIST_REQUEST, getProjectPostList);
    yield takeLatest(project.GET_PROJECTS_LIST_DATA_REQUEST, getProjectListData);
    yield takeLatest(project.GET_AUTO_ACCEPT_PROJECT_LIST_REQUEST, getAutoAcceptProjectList);
    yield takeLatest(project.GET_CONTACT_PERSON_DETAILS_REQUEST, getContactPersonDetails);
    yield takeLatest(project.GET_PROJECT_DETAIL_REQUEST, getProjectDetail);
    yield takeLatest(project.UPDATE_PROJECT_REQUEST, updateProjectDetail);
    yield takeLatest(project.GET_PROJECT_ELIGIBLE_PMS_LIST_REQUEST, getProjectPmsList);
    yield takeLatest(project.GET_TEAM_LIST_OF_PROJECT_REQUEST, getTeamListOFProject);
    yield takeLatest(project.ADD_TEAM_TO_PROJECT_REQUEST, addTeamToProject);
    yield takeLatest(project.REMOVE_TEAM_FROM_PROJECT_REQUEST, removeTeamFromProject);
    yield takeLatest(project.UPDATE_PROJECT_POST_REQUEST, updateProjectPost);
    yield takeLatest(project.GET_PROJECT_FILTER_LIST_REQUEST, getProjectFilterList);
    yield takeLatest(project.GET_MILESTONE_LIST_REQUEST, getMilestoneList);
    yield takeLatest(project.POST_MILESTONE_REQUEST, postMilestone);
    yield takeLatest(project.POST_MILESTONE_BY_ID_REQUEST, postMilestoneById);
    yield takeLatest(project.POST_PROJECT_MANAGER_REQUEST, postProjectManager);
    yield takeLatest(project.GET_PROJECT_MANAGER_REQUEST, getProjectManager);
    yield takeLatest(project.ADD_TEAMS_TO_PROJECT_REQUEST, addTeamsToProject);
    yield takeLatest(project.GET_MILESTONES_REQUEST, getMilestones);
    yield takeLatest(project.BLACK_LIST_USER_FROM_PROJECT_REQUEST, blackListUserFromProject);
    yield takeLatest(project.WHITE_LIST_USER_FROM_PROJECT_REQUEST, whiteListUserFromProject);
    yield takeLatest(project.REFRESH_PROJECT_LIST, refreshProjectList);
    yield takeLatest(project.ADD_PROJECT_PO_REQUEST, addProjectPo);
    yield takeLatest(project.EDIT_PROJECT_PO_REQUEST, editProjectPo);
    yield takeLatest(project.GET_PROJECT_PO_REQUEST, getProjectPo);
    yield takeLatest(project.GET_PROJECT_CHECKLIST_REQUEST, getProjectChecklist);
    yield takeLatest(project.EDIT_PROJECT_CHECKLIST_REQUEST, editProjectChecklist);
    yield takeLatest(project.ACTIVATE_PROJECT_REQUEST, activateProject);
};